// Import uniwersalnego wrappera do komunikacji z API (obsługuje GET/POST/DELETE itd.)
import { fetchWrapper } from "@/helpers/fetch-wrapper";

// Klasa obsługująca operacje na czarnej liście pojazdów (Black List)
class BlackListsService {

    /**
     * Dodaje nowy numer rejestracyjny do czarnej listy (Black List).
     *
     * Grupa kontaktów jest WYMAGANA — backend odrzuca żądanie bez przypisanej grupy.
     *
     * @param {string} licensePlate     Numer rejestracyjny pojazdu.
     * @param {string} description      Opis pojazdu.
     * @param {string|null} validFrom   Data od (YYYY-MM-DD) (opcjonalnie).
     * @param {string|null} validTo     Data do (YYYY-MM-DD) (opcjonalnie).
     * @param {number[]} contactGroupIds Identyfikatory grup kontaktów (wymagane, niepuste).
     * @returns Odpowiedź z API lub undefined jeśli brak wymaganych danych.
     */
    async postNewPlate(licensePlate, description, validFrom = null, validTo = null, contactGroupIds = []) {
        if (!licensePlate) {
            return;
        }

        if (!Array.isArray(contactGroupIds) || contactGroupIds.length === 0) {
            throw new Error('Wskaż co najmniej jedną grupę kontaktów, do której przypisana będzie tablica.');
        }

        const from = validFrom && String(validFrom).trim() !== '' ? String(validFrom).trim() : null;
        const to   = validTo && String(validTo).trim() !== '' ? String(validTo).trim() : null;

        if ((from && !to) || (!from && to)) {
            throw new Error('Both validFrom and validTo must be provided together.');
        }
        if (from && to && from > to) {
            throw new Error('validFrom cannot be later than validTo.');
        }

        const body = {
            plateLpr: licensePlate,
            typeOfList: 0, // 0 = czarna lista
            similarity: 1,
            description: description ?? '',
            contactGroupIds,
            ...(from && to ? { validFrom: from, validTo: to } : {}),
        };

        return await fetchWrapper.post(
            process.env.VUE_APP_API_URL + '/wanted-plates',
            body
        );
    }

    /**
     * Pobiera wszystkie pojazdy z czarnej listy (paginacja po 1000, sortowanie malejąco).
     */
    async getAll() {
        try {
            const params = new URLSearchParams();
            params.append('typesOfLists', '0');
            params.set('orderDirection', 'desc');
            params.set('page', '1');
            params.set('limit', '1000');

            const response = await fetchWrapper.get(
                `${process.env.VUE_APP_API_URL}/wanted-plates?${params.toString()}`
            );

            return response;
        } catch (error) {
            console.error('Error fetching vehicles:', error);
        }
    }

    /**
     * Usuwa pojazd z czarnej listy po ID.
     */
    async delete(id) {
        try {
            return await fetchWrapper.delete(
                `${process.env.VUE_APP_API_URL}/wanted-plates/${id}`
            );
        } catch (error) {
            console.error('Error deleting vehicle:', error);
        }
    }
}

export default new BlackListsService();
